/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerieSerieidLangsIdQueryResponse,
  GetApiV1SerieSerieidLangsIdPathParams,
  GetApiV1SerieSerieidLangsId401,
  GetApiV1SerieSerieidLangsId404,
  GetApiV1SerieSerieidLangsId500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsId.ts";

function getGetApiV1SerieSerieidLangsIdUrl(
  serieId: GetApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: GetApiV1SerieSerieidLangsIdPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serie/${serieId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Retorna uma tradução (idioma) de série pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter idioma por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/:id}
 */
export async function getApiV1SerieSerieidLangsId(
  serieId: GetApiV1SerieSerieidLangsIdPathParams["serieId"],
  id: GetApiV1SerieSerieidLangsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerieSerieidLangsIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsId401
      | GetApiV1SerieSerieidLangsId404
      | GetApiV1SerieSerieidLangsId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerieSerieidLangsIdUrl(serieId, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
